export const CleanExtension = (nameFile, format) => {
  return nameFile.replace(format, "");
};
